const SvgIcon = ({ size='13', color='#A59E9E' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 13 13"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M6.5 13a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m3.491-8.557a.325.325 0 1 0-.482-.436L5.616 8.31 3.474 6.265a.325.325 0 0 0-.449.47L5.41 9.01l.241.23.224-.247z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default SvgIcon;
